import React, { useEffect } from "react";
import { useOktaAuth } from "@okta/okta-react";
import { toRelativeUrl } from "@okta/okta-auth-js";
import { Outlet } from "react-router-dom";
import Loading from "./Loading";
import useAuthHandler from "../hooks/AuthHandler";

const SecureRoute = () => {
    const { oktaAuth, authState } = useOktaAuth();

    const { authHandler } = useAuthHandler();

    useEffect(() => {
        if (!authState) {
            return;
        }

        if (!authState?.isAuthenticated) {
            const originalUri = toRelativeUrl(
                window.location.href,
                window.location.origin
            );
            oktaAuth.setOriginalUri(originalUri);
            console.log("CALLING AUTH HANDLER");
            authHandler();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [oktaAuth, authState?.isAuthenticated, authHandler, !!authState]);

    if (!authState || !authState?.isAuthenticated) {
        return <Loading />;
    }

    return <Outlet />;
};

export default SecureRoute;
